<template lang="pug">
  r-table(
    loading-text='Cargando datos...'
    no-data-text='Sin datos encontrados.'
    no-search
    no-remove
    ref='table'
    v-bind='tableProps'
    @detail='submitShow'
  )
    template( slot='actions' slot-scope='props' )
      r-btn-action( 
        color='dark'
        tooltip='PDF'
        @click='submitPdf(props)' 
        )
        v-icon picture_as_pdf
    template( slot='items' )
      detail-dialog(
        :invoice-id='invoiceId'
        read-only
        ref='invoiceReceivableDialog'
        )
      nc-detail-dialog(
        :creditNoteId="creditNoteId"
        :creditNoteModel="CreditNoteMdl"
        read-only
        ref='creditNoteDialog'
        )
      nd-detail-dialog(
        :debitNoteId="debitNoteId"
        :debitNoteModel="debitNoteMdl"
        read-only
        ref="debitNoteDialog"
        )
</template>

<script>
  //
  import { RBtnAction, RTable } from '@/components/reusable_components/next'
  //
  import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
  import DetailCreditNoteDialog from '@/components/reusable_components/DocumentDetail/creditNote/CreditNoteDetail'
  import CreditNoteModel from '@/models/Sale/SlSaleCreditNote'
  import DetailDebitNoteDialog from '@/components/reusable_components/DocumentDetail/debitNote/DebitNoteDetail'
  import DebitNoteModel from '@/models/Sale/SlSaleDebitNote'
  //
  import SlTaxDocumentService from '@/services/api/Sale/SlTaxDocument'
  import SlTaxDocumentFilters from '@/views/Sale/SlTaxDocument/SlTaxDocumentFilters'
  import SlTaxDocumentHeaders from '@/views/Sale/SlTaxDocument/SlTaxDocumentHeaders'
  import SlCustomerBranchOfficesModel from '@/models/Sale/SlCustomerBranchOffices'
  //
  export default {
    name: 'customer-all-historic-invoice',
    components: {
      RBtnAction,
      RTable,
      'detail-dialog' : DetailDialog,
      'nc-detail-dialog' :DetailCreditNoteDialog,
      'nd-detail-dialog' :DetailDebitNoteDialog,
    },
    data() {
      return {
        headerTable: SlTaxDocumentHeaders,
        customerId: null,
        invoiceId: null,
        creditNoteId: null,
        CreditNoteMdl: CreditNoteModel,
        debitNoteId:null,
        debitNoteMdl: DebitNoteModel,
      }
    },
    computed: {
      branchOfficessProps() {
        return {
          noAsyncSearch: true, 
          paramFilter: { 
            sl_customer_id: this.$route.params.id,
          },
        }
      },
      tableProps() {
        return {
          service: SlTaxDocumentService.toList(),
          initialFilterValues: {
            sl_customer_id: this.$route.params.id,
            recent: '30', 
          },
          paramFilter: {
            sl_customer_id: this.$route.params.id,
          },
          headers: this.headerTable,
          filters: SlTaxDocumentFilters.exclude(['sl_customer_id']),
        }
      },
    },
    methods: {
      setCustomerId() {
        this.customerId = this.$route.params.id
        SlCustomerBranchOfficesModel
          .where('sl_customer_id', this.$route.params.id)
          .get()
          .then(this.setCustomerBranchOffices)
      },
      setCustomerBranchOffices(res) {
        SlTaxDocumentFilters.prop('sl_customer_branch_offices_id', {
          items: res.data,
        })
      },
      showPdf(model) {
        return model.toPdf()
      },
      submitPdf(event) {
        switch (event.item.dte_type) {
          case 33: event.item.fetchSaleInvoice().then(this.showPdf); break;
          case 61: event.item.fetchSaleCreditNote().then(this.showPdf); break;
        }
      },
      submitShow(event) {
        switch (event.item.dte_type) {
          case 33: //factura
            this.invoiceId = event.item.id
            this.$refs.invoiceReceivableDialog.open = true
            break
          case 61: //nota de crédito
            this.creditNoteId = event.item.id
            this.$refs.creditNoteDialog.open = true
            break
          case 56: //nota de débito
            this.debitNoteId = event.item.id
            this.$refs.debitNoteDialog.open = true
            break
        }
      },
    },
    beforeMount() {
      this.setCustomerId()
    },
  }
</script>
